var _clipPath, _filter, _rect, _g, _clipPath2, _filter2, _rect2, _g2, _clipPath3, _filter3, _rect3, _g3, _filter4, _rect4, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730 486",
    width: 730,
    height: 486,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4049",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4048",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4049)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 -315,210 -315,210 C-315,210 -315,-210 -315,-210 C-315,-210 315,-210 315,-210 C315,-210 315,210 315,210z"
  })))))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4053"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    d: "M0,0 L730,0 L730,486 L0,486z"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4057",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4056",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4057)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6,0,0,6,671.7310180664062,339.0710144042969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(255,204,221)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  })))))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4061"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    d: "M0,0 L730,0 L730,486 L0,486z"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4065",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4064",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4065)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6,0,0,6,671.7310180664062,339.0710144042969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(255,204,221)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  })))))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4084",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4083",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4084)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 -315,210 -315,210 C-315,210 -315,-210 -315,-210 C-315,-210 315,-210 315,-210 C315,-210 315,210 315,210z"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4090",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 -315.25,161 -315.25,161 C-315.25,161 -315,-210 -315,-210 C-315,-210 141,-210.25 141,-210.25 C141,-210.25 315,210 315,210z"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4044)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4048)",
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.000000238418579,0,0,1.000000238418579,692.9810180664062,360.3210144042969)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(255,204,221)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4056)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4053)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4083)",
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-30.23199462890625,-63.57098388671875)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,407.364990234375,276.3819885253906)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    stroke: "rgb(255,204,221)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-280.6759948730469,268.8819885253906 C-373.7869873046875,191.95399475097656 -399.864990234375,1.5609999895095825 -337.97698974609375,-37.68299865722656 C-216.8280029296875,-111.322998046875 -173.34300231933594,211.4250030517578 -253.42799377441406,169.343994140625 C-319.2510070800781,134.7570037841797 -306.1340026855469,-175.28199768066406 -88.27200317382812,-204.16600036621094 C399.8659973144531,-268.8819885253906 320.864990234375,153.18899536132812 320.864990234375,153.18899536132812"
  }))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4064)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4061)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4090)",
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-30.23199462890625,-63.57098388671875)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,407.364990234375,276.3819885253906)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 10,
    stroke: "rgb(255,204,221)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-280.6759948730469,268.8819885253906 C-373.7869873046875,191.95399475097656 -399.864990234375,1.5609999895095825 -337.97698974609375,-37.68299865722656 C-216.8280029296875,-111.322998046875 -173.34300231933594,211.4250030517578 -253.42799377441406,169.343994140625 C-319.2510070800781,134.7570037841797 -306.1340026855469,-175.28199768066406 -88.27200317382812,-204.16600036621094 C399.8659973144531,-268.8819885253906 320.864990234375,153.18899536132812 320.864990234375,153.18899536132812"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.f42d2bde5ee5ee24c7c6dd1ca5407571.svg";
export { ForwardRef as ReactComponent };